<template>
    <div class="p-four-o-four">
        <div class="p-four-o-four__container">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.4 72.2"><path class="st0" d="M36.3 0C16.2 0 0 16.2 0 36.1s16.2 36.1 36.3 36.1S72.4 56 72.4 36.1 56.1 0 36.3 0zm0 61.4c-14 0-25.3-11.3-25.3-25.3s11.3-25.3 25.3-25.3S61.6 22 61.6 36.1 50.1 61.4 36.3 61.4z"/><path class="st0" d="M68.8 70.7c-2.2 1.9-5.8 1.7-7.7-.6L55 63.2c-1.9-2.2-1.7-5.8.6-7.7 2.2-1.9 5.8-1.7 7.7.6l6.1 6.9c1.9 2.5 1.6 5.8-.6 7.7z"/></svg>
            <h1>404 Error</h1>
            <p>Sorry we couldn't find what you are looking for. If you believe you are receiving this page in error and a resource should be available here please <a href="mailto:abcquantum@bc-legal.co.uk">contact us.</a></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fourOFour'
    }
</script>

<style lang="scss">
    .p-four-o-four {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        height: 100%;
        &__container {
            width: 50%;
            text-align: center;
            h1 {
                font-size: 40px;
            }
            p {
                text-align: left;
            }
        }
        svg {
            fill: #09f;
            width: 200px;
        }
    } 
</style>


// WEBPACK FOOTER //
// 404.vue?09f39939